import React, {useEffect} from 'react';
import {useIntl, FormattedMessage} from 'react-intl';
import {Form, Button, Alert} from 'antd';
import {Input} from 'components/Form';
import {EnvironmentSettingsType} from '../../types';
import Spinner from 'components/Spinner';
import DefaultLayout from 'components/DefaultLayout';
import useQueryApiClient from "utils/useApiClient";

interface SMSSettingsTabProps {
    type: EnvironmentSettingsType;
    selectedResellerId: number;
    selectedCustomerId: number;
}

const SMSSettingsTab: React.FC<SMSSettingsTabProps> = ({type, selectedResellerId, selectedCustomerId}) => {
    const intl = useIntl();
    const [form] = Form.useForm();

    useEffect(() => {
        if (selectedResellerId !== 0 || selectedCustomerId !== 0) {
            fetch()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedResellerId, selectedCustomerId]);

    const {fetch, isFetching} = useQueryApiClient({
        request: {
            disableOnMount: type !== 'global',
            url: type === 'global' ? 'api/v1/environment/global/SMS' : `api/v1/environment/${type}/${selectedCustomerId ? selectedCustomerId : selectedResellerId}/SMS`,
        },
        onSuccess: (response) => {
            if (response?.noAppearanceSettingsFound) {
                form.resetFields();
            } else {
                form.setFieldsValue(response.settings);
            }
        },
    });

    const {appendData: submitForm, isLoading} = useQueryApiClient({
        request: {
            url: type === 'global'? 'api/v1/environment/global/SMS' : `api/v1/environment/${type}/${selectedCustomerId ? selectedCustomerId : selectedResellerId}/SMS`,
            method: 'POST',
        },
        onSuccess: () => {
        },
    });

    return (
        <>
            <Spinner spinning={isFetching || isLoading}>
                {
                    selectedCustomerId || selectedResellerId || type === 'global' ?
                        <>
                            <Form form={form} onFinish={submitForm}>
                                <Input name="smsSender"
                                       label={intl.formatMessage({id: 'system.environment.sms_sender'})}
                                       validation={{required: true}}/>
                            </Form>
                            <DefaultLayout.PageFooter
                                right={
                                    <Button
                                        type="primary"
                                        loading={isLoading}
                                        onClick={form.submit}
                                    >
                                        <span><FormattedMessage id="general.save"/></span>
                                    </Button>
                                }
                            />
                        </>
                        :
                        <Alert
                            message={intl.formatMessage({id: `system.environment.please_select_a_${type === 'organization' ? 'reseller' : 'customer'}`})}
                            type="info"
                            showIcon
                        />
                }
            </Spinner>
        </>
    );
}

export default SMSSettingsTab;